import React from "react";
import { Modal, Col, Button } from "react-bootstrap";
import styled from "styled-components";

const ElevatedModal = styled(Modal)`
  z-index: 99999;
  font-family: "YEKAN-BAKH-MEDIUM";
  text-align: center;
`;

function DistPrompt({
    title = "تخصیص توزیع",
    description = "آیا از صحت اطلاعات وارد شده اطمینان دارید؟",
    actionText = "بله",
    children,
    isOpen,
    onClose,
    onActionTap,
    ...rest
}) {
    return (
        <ElevatedModal
            show={isOpen}
            size='lg'
            centered
            animation={false}
            onHide={onClose}
            {...rest}
        >
            <Modal.Header closeButton>
                <Modal.Title className='w-100 d-flex justify-content-center align-items-center'>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"row p-1"}>
                    <Col md={12}>
                        <p>{description}</p>
                    </Col>
                </div>
                <div className="row p-1 mt-1 mx-2">
                    {children}
                </div>
                <div className="mt-2 mx-3">
                    <Col md={12}>
                        <Button
                            variant='success'
                            size={"lg"}
                            onClick={() => onActionTap?.()}
                            className={"w-100 mt-3"}
                        >
                            {actionText}
                        </Button>
                    </Col>
                </div>
            </Modal.Body>
        </ElevatedModal>
    );
}

export default DistPrompt;
